/* eslint-disable prettier/prettier */
export const section = [
  'w-full flex flex-col items-center bg-[#1A1726]',
].join(' ');

export const Wrapper = [
  'flex flex-col items-center w-full',
  'gap-[3.25rem] max-w-[23.438rem] pt-[4rem] gap-8 px-4 pb-[5rem]',
  'md:max-w-[70rem] md:pt-[7.5rem] md:gap-[4rem] md:px-0'
].join(' ');

export const motionWrap = [
  'flex flex-col w-full',
  'gap-2.5',
  'md:px-0 md:flex-row md:gap-5'
].join(' ');

export const card = [
  'relative flex overflow-hidden shadow-[inset_0_0_0_0.063rem_rgba(255,255,255,0.2)]',
  'rounded-xl',
  'md:flex-col md:w-[16.56rem] md:h-[21.06rem] md:rounded-lg'
].join(' ');

export const indexBadge = [
  'absolute top-1.5 left-1.5 flex items-center justify-center font-bold text-[#F9FAFB] bg-[#333236] rounded-full z-10',
  'py-[0.063rem] px-1.5 w-[1.17rem] h-[1.17rem] text-[0.78rem] leading-[0.78rem] tracking-[-0.019rem]',
  'md:py-[0.188rem] md:px-3 md:w-fit md:h-fit md:text-[0.936rem] md:leading-[1.557rem]'
].join(' ');

export const thumbWrap = [
  'relative flex-shrink-0 z-[1]',
  'w-[9rem] h-[7.3rem]',
  'md:w-full md:h-[13.437rem]'
].join(' ');

export const textBlock = [
  'flex flex-col',
  'px-4 items-start justify-center gap-2',
  'md:items-center md:gap-1 md:pt-4 md:px-5 md:pb-6'
].join(' ');

export const title = [
  'text-center text-[#F9FAFB] font-bold',
  'text-[1rem] leading-[1.5rem] tracking-[-0.019rem]',
  'md:text-[1.125rem] md:leading-[1.872rem]'
].join(' ');

export const description = [
  'text-[#FFFFFF99] font-medium whitespace-pre-line',
  'text-[0.875rem] leading-[1.25rem] tracking-[-0.019rem]',
  'md:text-center md:text-[0.873rem] md:leading-[1.503rem] font-normal'
].join(' ');
